import { contactMethodsFromFormkit, contactMethodsToFormkit, personContactConfig, type ContactMethodsFormkit } from "@/components/contactMethods";
import type { ContactMethodCollection } from "@/views/person/person";
import { emptyPerson, personDisplayName, type Person, type PersonCreate, type PersonFormKit } from "./person";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Person) {
  entity._authRequestFields = ["id"];
  return entity;
}

function getInitialData(): PersonFormKit {
  const result = emptyPerson();
  result._authRequestFields = ["id"];
  return result;
}

/** Be sure to await this when using it. Commonly used for lists and child lists. */
async function skinnyResponseAdapter(response: { data: Person }) {
  addAuthRequestFields(response.data);
  response.data.displayName = personDisplayName(response.data);
  return response.data as Person;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Person }) {
  await skinnyResponseAdapter(response);
  return response.data;
}

function requestAdapter(data: Person | PersonCreate | PersonFormKit) {
  const { affiliations: _affiliations, ...rest } = data as Person & { affiliations?: unknown };
  return {
    ...rest,
    contactMethods: contactMethodsFromFormkit(data.contactMethods, personContactConfig),
  };
}

function toFormkit<T extends Person | PersonCreate | PersonFormKit>(data: T) {
  const form = data as T & { contactMethods: ContactMethodsFormkit };
  form.contactMethods = contactMethodsToFormkit(data.contactMethods, personContactConfig);
}

function fromFormkit(data: Person | PersonCreate | PersonFormKit) {
  const source = data.contactMethods as ContactMethodsFormkit | ContactMethodCollection | null | undefined;
  (data as { contactMethods: ReturnType<typeof contactMethodsFromFormkit> }).contactMethods = contactMethodsFromFormkit(
    source,
    personContactConfig,
  );
}
